import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'pos-app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input() partial: boolean = false;
  @Input() show: boolean = false;
  @Input() dark: boolean = false;
  @Input() inline: boolean = false;
  @Input() showTextLoader: boolean = false;
  @Input() displayText: string = '';
  constructor() {}

  ngOnInit() {}
}

